import React, {Component} from 'react';
import {Icon, Divider} from 'semantic-ui-react';

class UnderConstruction extends Component {
  render() {
    return (
      <div className='under-construction'>
        <div className='icon'>
          <Icon.Group size='huge'>
            <Icon loading size='big' name='sun' />
            <Icon name='hourglass three' size='small' />
          </Icon.Group>
        </div>
        <Divider />
        <div className='ui huge message'>
          Esta página esta en construcción =)
        </div>
      </div>
    );
  }
}

export default UnderConstruction;
